<script setup lang="ts">
import type { NuxtError } from '#app';
import Text from '~/components/shared/Text.vue';
import Button from '@/components/shared/button/Button.vue';
import { useWebsiteStore } from '~/stores/websiteStore';

interface Props {
  error: NuxtError;
}

const DEFAULT_ERROR_TEXT = 'Произошла непредвиденная ошибка, уже исправляем! Мы всегда рады видеть вас в нашем каталоге или на главной странице';
const ERROR_TEXTS: Record<number, string> = {
  404: 'Cтраница удалена или у неё поменялся адрес. Мы всегда рады видеть вас в нашем каталоге или на главной странице',
};
const HOME_URL = '/';
const CATALOG_URL = '/catalog';

const websiteStore = useWebsiteStore();

const props = defineProps<Props>();
const { statusCode, message } = props.error;

const getErrorText = (statusCode?: number, message?: string): string => {
  if (statusCode === 500 && message) {
    return `На сервере произошла ошибка: ${message}`;
  }
  return ERROR_TEXTS[statusCode || -1] || DEFAULT_ERROR_TEXT;
};

const isPage404 = computed(() => statusCode === 404);

const computeErrorText = () => getErrorText(statusCode, message);
const errorText = computed(computeErrorText);

const redirectTo = (redirect: string) => {
  // clearError({ redirect });
  window.location.href = redirect;
};

onMounted(() => {
  nextTick(() => {
    window.scrollTo(0, 0);
    websiteStore.pageHiddenPoint = false;
    websiteStore.disablePageAnimation = false;
  });
});
</script>

<template>
  <!--  <NuxtLayout> -->
  <main class="error-page">
    <div class="error-page__content">
      <img
        v-if="isPage404"
        src="~/assets/images/pages/error/404.svg"
        alt="Изображение с кодом ошибки 404"
        class="error-page__image"
      />

      <img
        v-else
        src="~/assets/images/pages/error/500.svg"
        alt="Изображение с кодом ошибки 500"
        class="error-page__image"
      />

      <Text v-if="isPage404" class="error-page__desc"><span v-html="errorText"/></Text>

      <div class="error-page__buttons">
        <Button @click="redirectTo(HOME_URL)">На главную</Button>

        <Button secondary @click="redirectTo(CATALOG_URL)">В каталог</Button>
      </div>
    </div>
  </main>
<!--  </NuxtLayout> -->
</template>

<style lang="scss" scoped>
.error-page {
  position: relative;
  height: 100vh;

  @media ($media-tablet) {
    display: flex;
    align-items: center;
  }

  &__image {
    display: block;
    height: 313px;
    margin-bottom: 32px;

    @media ($media-tablet) {
      margin-bottom: -4px;
    }
  }

  &__content {
    width: 608px;
    height: fit-content;
    top: 50%;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;

    @media ($media-tablet) {
      position: static;
      top: unset;
      left: unset;
      height: auto;
      transform: unset;
      width: 100%;
      padding: 0 16px 20px 16px;
    }
  }

  &__buttons {
    display: flex;
    gap: 16px;
    justify-content: center;
  }

  &__desc {
    text-align: center;
    margin-bottom: 24px;
  }
}
</style>
